import { render, staticRenderFns } from "./AccesoriosCard.vue?vue&type=template&id=18c6c1f2&"
import script from "./AccesoriosCard.vue?vue&type=script&lang=js&"
export * from "./AccesoriosCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports